<template>
  <div class="info-box">
    <div class="head-box">
      <div class="c-flex-space-between c-flex-align-center">
        <p class="p1">{{ $t('user_assets.bankAccountNumber') }}</p>
        <div
          class="btn2"
          @click="
            $message({
              type: 'warning',
              message: '开发中...',
            })
          "
        >
          {{ $t('user_center.account_setting.add') }}
        </div>
      </div>
      <p class="p2 mt8">
        {{ $t('user_center.tip_val2') }}
        
      </p>
    </div>
    <div class="box2 c-flex1 c-flex-column">
      <NoData v-if="tableData.length <= 0" />
      <el-table
        v-else
        :data="tableData"
        style="width: 100%"
        header-cell-class-name="table-head"
        cell-class-name="table-cell"
      >
        <el-table-column prop="address" label="时间" />
        <el-table-column prop="address" label="类型" />
        <el-table-column prop="address" label="登录地址" />
        <el-table-column prop="address" label="现状">
          <template slot-scope="{ row }">
            <el-tag type="danger">成功</el-tag>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import NoData from "./NoData";
export default {
  components: {
    NoData,
  },
  data() {
    return {
      currTab: "登录历史",
      inputValue: "",
      tableData: [],
    };
  },
  mounted() {},
  methods: {
    tabChange(val) {
      this.currTab = val;
    },
  },
};
</script>

<style lang="less" scoped>
.info-box {
  padding: 40px;
  background: #ffffff;
  border-radius: 22px 22px 22px 22px;
  .head-box {
    padding-bottom: 36px;
    border-bottom: 1px solid #e2e3e3;
  }
  .p1 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 800;
    font-size: 24px;
    color: #333333;
  }
  .p2 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #999999;
  }
  .p3 {
    font-family: PingFang SC, PingFang SC;
    font-weight: 800;
    font-size: 18px;
    color: #333333;
  }
  .btn2 {
    width: 112px;
    height: 48px;
    cursor: pointer;
    line-height: 48px;
    text-align: center;
    background: #4063ff;
    border-radius: 8px 8px 8px 8px;
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #ffffff;
  }
  .item-box {
    display: flex;
    margin-top: 32px;
    justify-content: space-between;
    img {
      width: 24px;
      height: 24px;
      margin-right: 8px;
    }
    .item-btn {
      gap: 32px;
      display: flex;
      align-items: center;
    }
  }
  .input-box {
    gap: 120px;
    display: flex;
    justify-content: space-between;
  }
  /deep/ .el-form-item__label {
    font-family: PingFang SC, PingFang SC;
    font-weight: 400;
    font-size: 16px;
    color: #999999;
  }
}
.box2 {
  margin-top: 20px;
  /deep/.table-head {
    background: rgba(234, 235, 237, 0.5);
  }
  /deep/.table-head:first-child {
    border-radius: 6px 0px 0px 6px;
  }
  /deep/.table-head:last-child {
    border-radius: 0px 6px 6px 0px;
  }
  /deep/.table-cell {
    border: none;
  }
  /deep/ .el-table__body tr.current-row > td {
    background-color: rgba(225, 234, 255, 0.6) !important;
  }
  /deep/ .el-table--enable-row-hover .el-table__body tr:hover > td {
    background-color: rgba(225, 234, 255, 0.6) !important;
  }
}
</style>
